import React from 'react';

/**
 * RoleChangeWarningModal — extracted from AdminPage.jsx (iter134 refactor).
 * Warns admins that demoting a user with active moderator seats does not
 * revoke those seats automatically. Presentation only; parent owns state.
 */
export const RoleChangeWarningModal = ({ prompt, onCancel, onConfirm }) => {
  if (!prompt?.open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      data-testid="role-change-warning-modal"
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md m-4">
        <div className="p-6 border-b border-slate-200">
          <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-2">
            <span className="inline-flex w-8 h-8 items-center justify-center rounded-full bg-amber-100 text-amber-700">
              {'\u26A0'}
            </span>
            Demote {prompt.userLabel}?
          </h3>
          <p className="text-sm text-slate-600 mt-2">
            This user currently holds <strong>{prompt.seats.length}</strong>{' '}
            active moderator seat{prompt.seats.length === 1 ? '' : 's'}. Changing the role does <strong>not</strong>{' '}
            automatically revoke those seats — the user will keep access to these specific AI Employees until each seat is manually removed.
          </p>
        </div>
        <div className="p-6 space-y-3 max-h-64 overflow-y-auto">
          <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">Chatbots the user is moderator on</p>
          <ul className="space-y-2">
            {prompt.seats.map((seat) => (
              <li
                key={seat.chatbot_id}
                className="flex items-center gap-2 text-sm text-slate-700 p-2 bg-slate-50 border border-slate-200 rounded"
                data-testid={`role-warning-seat-${seat.chatbot_id}`}
              >
                <span className="w-2 h-2 rounded-full bg-amber-500 flex-shrink-0" />
                <span className="font-medium">{seat.chatbot_name}</span>
                <span className="text-xs text-slate-400 ml-auto">{seat.chatbot_id}</span>
              </li>
            ))}
          </ul>
          <p className="text-xs text-slate-500 pt-2">
            To fully revoke access, open each AI Employee &rarr; Moderators tab and remove the seat, or continue and revoke seats later.
          </p>
        </div>
        <div className="p-4 border-t border-slate-200 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded hover:bg-slate-50"
            data-testid="role-warning-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-amber-600 rounded hover:bg-amber-700"
            data-testid="role-warning-confirm"
          >
            Change role anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleChangeWarningModal;
